import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {removeFCMToken} from '../../../lib/firebase'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    const performLogout = async () => {
      await removeFCMToken()
      logout()
      document.location.reload()
    }
    performLogout()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
